import Tag from 'models/tag/Tag';

/**
 * Class representing a item tag.
 * @extends Tag
 */
export default class ItemTag extends Tag {}
